import { Module } from 'vuex';
import { RootState } from '@/store/state';
import state, { UserState } from '@/store/modules/user/state';
import actions from '@/store/modules/user/actions';
import mutations from '@/store/modules/user/mutations';

const UserModule: Module<UserState, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations,
};

export default UserModule;
